export type SSOLoginNames =
    | 'facebook-auth'
    | 'google-auth'
    | 'google-onetap-auth';

type SSOLoginSuccessTypes = {
    name: SSOLoginNames;
};

export const formatSuccessData = ({ name }: SSOLoginSuccessTypes) => {
    return { name, success: 'true' };
};
